import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import { QuestionInputTypes } from '../form';
export var RedeemRewardOutput = t.type({
  redeemReward: t.union([t.type({
    __typename: t.literal('RedeemRewardErrors'),
    errors: t.array(t.type({
      message: t.string
    }))
  }), t.type({
    __typename: t.literal('RedeemRewardResult'),
    message: nullable(t.string)
  })])
});
export var ShippingAddressInput = t.intersection([t.type({
  phoneNumber: t.string,
  fullName: t.string,
  address: t.string,
  city: t.string,
  country: t.string,
  postalCode: t.string
}), t.partial({
  address2: nullable(t.string),
  region: nullable(t.string)
})]);
export var RewardInput = t.intersection([t.type({
  id: t.string
}), t.partial({
  responses: t.array(QuestionInputTypes.Response),
  shippingAddress: ShippingAddressInput
})]);
export var RedeemRewardInput = t.type({
  input: RewardInput
});
export var EditShippingAddressResult = t.type({
  __typename: t.literal('EditShippingAddressResult'),
  address: t.type({
    address: t.string
  })
});
export var ShippingAddressOutput = t.type({
  editShippingAddress: t.union([t.type({
    __typename: t.literal('EditShippingAddressErrors'),
    errors: t.array(t.type({
      message: t.string
    }))
  }), EditShippingAddressResult])
});
export var EditShippingAddressInput = t.type({
  input: ShippingAddressInput
});